import React from "react";
import PropTypes from "prop-types";

import { Header, Icon } from "semantic-ui-react";

import Tooltip from "components/Tooltip";

export function DefaultSettingsHint({ description, title }) {
  return (
    <Header as="h4" style={{ display: "flex" }}>
      {title}
      <div>
        <Tooltip
          data-test="default-team-info-popup"
          title={description}
          position="top center"
        >
          <Icon
            data-test="default-team-info-icon"
            name="info circle"
            color="grey"
            style={{ marginLeft: "0.5em" }}
          />
        </Tooltip>
      </div>
    </Header>
  );
}

DefaultSettingsHint.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

DefaultSettingsHint.defaultProps = {
  title: "Default Settings",
  description:
    "For Service Team Role assignees, default settings will be used when no users are selected",
};

export default DefaultSettingsHint;
